/**
 * @generated SignedSource<<5985c7fc03c2daa4969c3d5edd6f78f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newsletterArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"headerNewsletterArticleArticle" | "issuesNewsletterArticleArticle">;
  readonly " $fragmentType": "newsletterArticleArticle";
};
export type newsletterArticleArticle$key = {
  readonly " $data"?: newsletterArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"newsletterArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "newsletterArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerNewsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "issuesNewsletterArticleArticle"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "967b249f22bddad284618490b507877b";

export default node;
